import React, {useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import anexoFormularioStyle from "../../assets/jss/material-dashboard-pro-react/components/anexoFormularioStyle";
import {DropzoneAreaBase} from 'material-ui-dropzone'
import ReactTable from "../../components/ReactTableWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExchangeAlt, faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";

const AnexoFormulario = (props) => {
  const {classes} = props;

  const [modal, setModal] = useState();

  const id_utilizador = props.utilizador;

  const id_resposta_formulario = props.submissao.id;
  const data_submissao = props.submissao.data_submissao;
  const anexos = props.submissao.anexos;

  const apagarAnexo = (id, nome) => {
    setModal(<SweetAlert
      warning
      title="Remover Anexo"
      onConfirm={async () => {
        await connection.post(`forms/anexo_resposta_formulario/${id}/apagar?id_submissao=${id_resposta_formulario}`);
        props.reload();
        setModal(null);
      }}
      onCancel={() => setModal(null)}
      confirmBtnCssClass={
        classes.button + " " + classes.danger
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Apagar"
      cancelBtnText="Cancelar"
      showCancel
    >
      Quer apagar o anexo {nome}?
    </SweetAlert>)
  }

  const alterarAnexo = (id_anexo, nome) => {
    let aprov = {};

    let id = parseInt(Math.random() * 10000, 10);

    setModal(<SweetAlert
      warning
      title="Alterar Anexo"
      onConfirm={async () => {
        let form_data = new FormData();

        if (aprov.ficheiro)
          form_data.append("ficheiro", aprov.ficheiro);

        await connection.post(`forms/anexo_resposta_formulario/${id_anexo}/alterar?id_submissao=${id_resposta_formulario}`, form_data, (data) => {
          general.success("Anexo Alterado", "Sucesso");
          props.reload();
          setModal(null);
        });
      }}
      onCancel={() => setModal(null)}
      confirmBtnCssClass={
        classes.button + " " + classes.danger
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Alterar"
      cancelBtnText="Cancelar"
      showCancel
    >
      <form autoComplete="off" className={classes.addForm} style={{marginTop: 10}}>
        <div style={{textAlign: "center", marginTop: "10px"}}>
          <label htmlFor={"raised-button-file-" + id}>
            <input
              accept=".pdf, .docx, .doc, .png, .jpg, .jpeg"
              className={classes.input}
              id={"raised-button-file-" + id}
              type="file"
              onChange={(e) => {
                if (e.target.files.length > 0) {
                  aprov.ficheiro = e.target.files[0];
                  $("#file-upload-name-" + id).text(e.target.files[0].name);
                }
              }}
            />
            <p id={"file-upload-name-" + id}></p>
          </label>
        </div>
      </form>
      Quer alterar o anexo {nome}?
    </SweetAlert>)
  }

  return <>
    {modal}
    <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Anexos</h4>
        </div>
      </CardHeader>
      {!data_submissao && <DropzoneAreaBase
        filesLimit={1}
        dropzoneText={"Arraste ficheiro para adicionar um novo anexo"}
        onAdd={async (files) => {
          let form_data = new FormData();
          form_data.append("ficheiro", files[0].file);
          let resultado = await connection.post(`forms/anexo_resposta_formulario/${id_resposta_formulario}/adicionar?utilizador=${id_utilizador}`, form_data);
          props.reload();
          general.success("Anexo adicionado com sucesso")
        }}
        showAlerts={false}
        fileObjects={[]}
        classes={{root: classes.dropzoneRoot}}/>}
      <ReactTable
        placeholder={"Sem anexos"}
        data={anexos}
        minRows={1}
        columns={[
          {
            Header: "Data de Criação",
            accessor: "data",
            Cell: ({value}) => general.Renderers.dateRenderer(value, {hide_timezone: true})
          },
          {
            Header: "Utilizador",
            accessor: "criado_por",
            Cell: general.Renderers.userRenderer
          },
          {
            Header: "Informação",
            accessor: "informacoes_ficheiro",
            width: 300,
            Cell: ({value}) => {
              let dados = JSON.parse(value);
              return dados.name;
            }
          },
          {
            Header: "",
            maxWidth: 110,
            sortable: false,
            filterable: false,
            Cell: ({original}) => <React.Fragment>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  window.open(connection.getFullUrl(original.path))
                }}
                style={{margin: 0}}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
              {!data_submissao && <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  apagarAnexo(original.id, JSON.parse(original.informacoes_ficheiro).name)
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>}
              {general.userHasType("secretario_regional", "admin") && data_submissao && <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  alterarAnexo(original.id, JSON.parse(original.informacoes_ficheiro).name)
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faExchangeAlt}/>
              </Button>}
            </React.Fragment>
          }
        ]}
        defaultPageSize={10}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  </>;
}

export default withStyles(anexoFormularioStyle)(AnexoFormulario);
